module.exports = __webpack_public_path__ + "static/media/top_gb.fd5fecac.svg";